import APIClient, { failSafe, makeCancellableAPIRequest } from "./index";

const ReportsAPI = {
    getAll(params){
        return failSafe(
            APIClient.get("/compliance/reports", {params})
        );
    },
    getHistoryReports(reportId, snapshotId) {
        return failSafe(
            APIClient.get(`/compliance/reports/${reportId}/snapshots/${snapshotId}`)
        )
    },
    get(id){
        return failSafe(
            APIClient.get(`/compliance/reports/${id}`)
        );
    },
    post(policyId,envs, isAllProducts=false) {
        return failSafe(
            APIClient.post(`/compliance/reports`, {policies: [{policyId,envs, isAllProducts}]})
        )
    },
    getSnapShot(reportId) {
        return failSafe(
            APIClient.get(`/compliance/reports/${reportId}/snapshots`)
        )
    },
    getRuleEvents(reportId,snapshotId, ruleId){
        return makeCancellableAPIRequest(
            "GET",
            snapshotId ? `/compliance/reports/${reportId}/snapshots/${snapshotId}/evidences/${ruleId}/events` :
            `/compliance/reports/${reportId}/evidences/${ruleId}/events` 
        )
    },
    postRuleComment(reportId, ruleId, comment, userIds){
        return makeCancellableAPIRequest(
            "POST",
            `/compliance/reports/${reportId}/evidences/${ruleId}/comments`,
            {
                data: { comment, userIds }
            }
        )
    },
    getFilters(){
        return makeCancellableAPIRequest(
            "GET",
            "compliance/report-filters",
        )
    },
    compare(report1, report2) {
        return makeCancellableAPIRequest(
            "GET",
            `/compliance/reports/compare/${report1}/${report2}`
        )
    },
    uploadFile(reportId,evidenceId,fileName, note){
        return makeCancellableAPIRequest(
            "POST",
            `/compliance/reports/${reportId}/evidences/${evidenceId}/files`,
            {
                data: { fileName, note }
            }
        )
    },
    deleteFile(reportId, evidenceId, fileId, note) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/compliance/reports/${reportId}/evidences/${evidenceId}/files/${fileId}`,
            {
                data: {note}
            }
        )
    },
    updateReport(reportId,evidenceId, data){
        return makeCancellableAPIRequest(
            "PUT",
            `/compliance/reports/${reportId}/evidences/${evidenceId}`,
            {
                data
            }
        )
    },
    getDownloadurl(reportId,snapshotId,evidenceId, fileId) {
        return makeCancellableAPIRequest(
            "GET",
            snapshotId ? `/compliance/reports/${reportId}/snapshots/${snapshotId}/evidences/${evidenceId}/files/${fileId}` :
            `/compliance/reports/${reportId}/evidences/${evidenceId}/files/${fileId}`
        )
    },
    getSimilarRuleFailedSubproduct(productId, ruleTitle){
        return makeCancellableAPIRequest(
            "POST",
            `/compliance/subproducts/product/${productId}/rule`,
            {
                data: { ruleKey: ruleTitle }
            }
        )
    }
}

export default ReportsAPI;